// extracted by mini-css-extract-plugin
export var externalLink = "_bx-0";
export var internalLinkLabel = "_bx-1";